export default __webpack_public_path__ + "static/media/learning.da5310a4.webp";